import { getEndpoint, ENDPOINT_GENNEMSNITLON_PERSONGRUPPER, ENDPOINT_STATISTICS_EXPERIENCE, ENDPOINT_STATISTICS_EDUCATION } from '../../services/service-some-api';
import { externalTooltipHandler, getTooltipStatistics } from './custom-tooltip';
import {  setGlobalChartConfig, convertHEXtoRGB, setRGBTransparency } from '../../services/service-utils';
import { Educations, ChartColors  } from '../../consts/const-utils';
import { setXScaleProps, updateSalaryLegendStyle } from './chartjs-const';
import { EventBus, EventTypes } from '../../consts/const-event-types';

export default class ChartJSComponent {
  constructor(element) {
    this.el = element
  
    // Variables and config
    this.ctx = this.el.querySelector('.chart-canvas').getContext('2d');
    this.myChart = null;

    this.barThickness = 10;

    this.salaryGroup = "Standard";
    this.backgroundEducationColors = [];

    this.checkboxEducationsLegend = this.el.querySelector("[data-checkbox-education-legend]");

    this.savedDataPoint = {
      label: null,
      datasets: []
    }

    // Bindings
    this.loadData = this.loadData.bind(this);
    this.loadStatistics = this.loadStatistics.bind(this);
    this.setupChart = this.setupChart.bind(this);
    this.externalTooltipHandlerWrapper = this.externalTooltipHandlerWrapper.bind(this);
  
    // Functions
    this.init()
  }

  init()
  { 
    this.loadStatistics();    
  }

  setupGlobalEvents()
  {
    EventBus.addEventListener(EventTypes.CHART_GLOBALFILTER_UPDATE, event => 
    {
      const { 
        dataComponent,
        highlightedGroups,
        hidePublicLeaders
      } = event.detail;


      if(dataComponent === this.el.getAttribute("data-component") || dataComponent == "all")
      {


        // Remove / Add leaders depending of what is selectdd
        this.toggleLeadersVisibility(hidePublicLeaders);


        this.setHighlightedData(highlightedGroups);
      }
    });

    EventBus.addEventListener(EventTypes.SALARY_LEGEND_UPDATE, event => 
    {
      const { 
        chartElement,
        salaryGroup 
      } = event.detail;

      // We update the salary legend on every chart that has the salary legend, whenever we click on it
      // This below updates the salary "selected" state on any other salary legend than the one you click on
      if(chartElement.getAttribute("data-component") != this.el.getAttribute("data-component"))
      {
        updateSalaryLegendStyle(this.el, salaryGroup);
      }

      // Whenever somebody switched the salary legend on this chart of any other, we will also change this one
      this.salaryGroup = salaryGroup;
      this.setupChart();

    });
  }



  setupChart()
  {
    if(this.myChart){   
      this.savedDataPoint.label = null;
      this.myChart.destroy();
    
    }

    if(this.ctx)
    {
      setGlobalChartConfig();

      Chart.Tooltip.positioners.custom = function(elements, eventPosition) {
        /** @type {Chart.Tooltip} */
        var tooltip = this;
    
        return {
            x: eventPosition.x,
            y: eventPosition.y
          };
      }

      const dataSorted = this.data[this.salaryGroup].sort((a, b) => b.Value - a.Value);
      const dataLabels = dataSorted.map(p => p.Group);
      const dataValues = dataSorted.map(p => p.Value);

      this.getDatasetColors(dataLabels); 


      // Calculate height of chart based on amount of data
      this.el.style.height = `${(dataLabels.length * 2) * (this.barThickness * 2)}px`;



      this.myChart = new Chart(this.ctx, 
        {
        type: 'bar',
        data: 
        {
            labels: dataLabels,
            datasets: [
              {
                data: dataValues,
                backgroundColor: this.checkboxEducationsLegend.checked && this.backgroundEducationColors.length > 0 ? this.backgroundEducationColors : ChartColors[0],
                barThickness: this.barThickness,
              },
            ]
        },
        options: 
        {
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: 'y',
            barPercentage: 1,
            interaction: {
              intersect: true,
              mode: 'nearest',
            },
            layout: {
              padding: 0
          
            },
            scales:
            {
              x:{
                position: "top",
                ...setXScaleProps()
              },
              x2:{
                ...setXScaleProps(false),
              },
              y:{
                
                grace: "5%",
                grid: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  mirror: true,
                  z: 1,
                  padding: 0,
                  labelOffset: -(this.barThickness * 1.40),
                  font: {
                    size: 13,
                    weight: "bold"
                  },
                
                },          
              }
            },
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,    
                position : 'custom',        
                external: this.externalTooltipHandlerWrapper
              },
            }
        },
        plugins: [],
      });

      // Set same Y scale values
      this.myChart.options.scales.x.max =  this.getHighestXValue();
      this.myChart.options.scales.x2.max = this.myChart.options.scales.x.max; 
      this.myChart.update();


      // Check for Global filter
      const eventData = {
        detail: this.el.getAttribute("data-component")
      }
      const ev = new CustomEvent(EventTypes.CHART_GLOBALFILTER_REQUEST, eventData)
      EventBus.dispatchEvent(ev);

     
    }
  }


  setHighlightedData(highlightedGroups)
  {  

    var backgroundColors = [];

    let highlightedIndex;


    this.myChart.data.labels.forEach((label, index) => 
    {
      highlightedGroups.forEach(h => 
      {
        if(h === label)
        {
          highlightedIndex = index;
        }
      })

      // Update colors
      if(index == highlightedIndex || highlightedGroups.length == 0)
      {
        var color = this.checkboxEducationsLegend.checked ? this.backgroundEducationColors[index] : ChartColors[0];
        backgroundColors.push(color);
      }
      else
      {    
        var color = this.checkboxEducationsLegend.checked ? this.backgroundEducationColors[index] : ChartColors[0];
        color = convertHEXtoRGB(color);
        backgroundColors.push(setRGBTransparency(color));              
      }
    });

    // Set colors
    this.myChart.data.datasets.forEach((dataset) => 
    {
        dataset.backgroundColor = backgroundColors;
    });

    // Update rendering
    this.myChart.update();
  }

  toggleLeadersVisibility(hidePublicLeaders)
  {
    if(hidePublicLeaders)
    {
      this.myChart.data.labels.forEach((label, index) => 
      {
        if(label == "Offentlige chefer")
        {
          this.removeData(index);
        }
      });
    }
    else{
      // Show
      this.addData();
    }

  }

  addData()
  {
    // Only add if data is there
    if(this.savedDataPoint.label)
    {
      // Insert label at right place
      this.myChart.data.labels.splice(this.savedDataPoint.index,0, this.savedDataPoint.label);

      // insert datapoints at right place
      this.myChart.data.datasets.forEach((dataset, index) => {

          dataset.data.splice(this.savedDataPoint.index,0, this.savedDataPoint.datasets[index]);

 

          dataset.backgroundColor =  this.backgroundEducationColors.splice(this.savedDataPoint.index,0, this.savedDataPoint.backgroundColor[index]);

         
      });

      this.myChart.update();

      // Reset
      this.savedDataPoint.label = null;
      this.savedDataPoint.backgroundColor = null;
    }
  }



  removeData(index)
  {
    if(this.savedDataPoint.label == null)
    {
      this.savedDataPoint = {
        index: index,
        label: this.myChart.data.labels[index],
        datasets: [],
        backgroundColor: [],
      }

      // Remove label
      this.myChart.data.labels.splice(index, 1);


      this.myChart.data.datasets.forEach((dataset) => {
    
        // Add to saved
        this.savedDataPoint.datasets.push(dataset.data[index]);
        this.savedDataPoint.backgroundColor.push(dataset.backgroundColor[index]);

        // remove it
        dataset.data.splice(index, 1);

        dataset.backgroundColor = this.backgroundEducationColors.splice(index, 1);      
      });

      this.myChart.update();

    }
  }



  getHighestXValue()
  {
    var value = 0;

    this.myChart.data.datasets.forEach((dataset) => 
    {
      if(dataset.hidden == false || dataset.hidden == null)
      {
        const highestY = Math.max(...dataset.data.map(d => d));

        if(value < highestY)
        {
          value = highestY;
        }
      }
    });

    // Buffer on top
    value = Math.ceil(value  / 100) * 100;

    return value;
  }

  renderCustomLegend()
  {
    const legend = this.el.querySelector("[data-custom-legend]");

    const template = `
    <ul>
    ${Educations.map(e => `<li class="selected"><span class="legend-color" style="background-color: ${e.color}"></span>${e.name}</li>`).join('')}
    </li>
    `;

    legend.innerHTML = template;    


    if(this.checkboxEducationsLegend)
    {
      //this.checkboxEducationsLegend.checked ? legend.classList.remove("hide") : legend.classList.add("hide");

      const setCheckbox = () => {

        this.legendWrapper = legend.parentElement;
        
        this.legendWrapper.style.height = `${legend.clientHeight}px`;

        if(this.checkboxEducationsLegend.checked)
        {          
          // Allows the height to be fully flexible if height is changed on device while in an open state
          setTimeout(() => {
            this.legendWrapper.style.height = `auto`;
          }, 1000) 
        }
        else{   
          setTimeout(() => {
            this.legendWrapper.style.height = `0px`;
          }, 50);  
        }

        this.setupChart();
      }

      // Add events to checkbox
      this.checkboxEducationsLegend.addEventListener("click", () => {      

        setCheckbox();
      })
    }
    


  }

  getDatasetColors(labels)
  {
    this.backgroundEducationColors = [];

    labels.forEach(label => {
      const stat = this.dataStatisticsExperience.Sheet1.filter((d) =>  {
        return d.Group === label;
      });
      
      if(this.dataStatisticsExperience && stat && stat[0].Education)
      {
        const color = stat[0].Education.Color.trim();
        this.backgroundEducationColors.push(color);      
      }
    }); 


  }

  externalTooltipHandlerWrapper(context)
  {
    const statsHTML = getTooltipStatistics(context, this.dataStatisticsExperience);
    externalTooltipHandler(context, statsHTML);
  }

  async loadData()
  {
    this.data = await getEndpoint(ENDPOINT_GENNEMSNITLON_PERSONGRUPPER);

    if(this.data)
    {
      this.setupChart();
    }
  }

  async loadStatistics()
  {
    this.dataStatisticsExperience = await getEndpoint(ENDPOINT_STATISTICS_EXPERIENCE);

    if(this.dataStatisticsExperience)
    {
      this.dataStatisticsEducation = await getEndpoint(ENDPOINT_STATISTICS_EDUCATION);

      if(this.dataStatisticsEducation)
      {
        // Loop through first on and find similar matches in seccond array
        this.dataStatisticsExperience.Sheet1.forEach(exp => 
        {
          this.dataStatisticsEducation.Sheet1.forEach(edu => 
          {
            if(exp.Group === edu.Group)
            {
               // Merge eduction into the object of the first one
              exp.Education = edu;

              // Add Education color based on Education key
              Object.keys(exp.Education).forEach(key => {

                if(key != "Group")
                {
                  const educationItem = Educations.filter(e => e.shortname === key);  
                  if(educationItem && educationItem.length > 0)
                  {
                    exp.Education.Color = educationItem[0].color;
                  }   
                }                                
              });
            }
          })
        })

         this.renderCustomLegend() 

         this.loadData();

         this.setupGlobalEvents();
        

      }
    }
  }
}
